(function() {
  if(location.search.includes('variant=')) {
    const preselectedVariant = location.search.split('variant=')[1];
    const preselectedVariantLabel = document.querySelector(`.block__cbwrapper [for="${preselectedVariant}"]`);
    if (!preselectedVariantLabel) return;

    preselectedVariantLabel.click();
    preselectedVariantLabel.scrollIntoView({block: 'center', behavior: 'smooth'});
  }

  const shopPayElement = document.querySelector('shopify-payment-terms');

  if (shopPayElement) {
    const style = document.createElement('style');

    style.textContent = `
      #shopify-installments {
        text-align: center;
      }
    `;

    shopPayElement.shadowRoot.appendChild(style);
  }
})();